import { createFileRoute } from '@tanstack/react-router';
import { BoundaryEditorPage } from '@/features/boundaries/BoundaryEditorPage';

export const Route = createFileRoute('/_staff/staff/projects_/$projectId/boundary_/$objectId')({ component: BoundaryViewRoute });

function BoundaryViewRoute() {
  const { projectId, objectId } = Route.useParams();
  return <BoundaryEditorPage key={objectId} projectId={projectId} viewObjectId={objectId} />;
}
